{{#if isPipelinedWrite}}
virtual function void resp_received();
  {{ respEvtVariable.identifier }}.trigger();
endfunction
{{/if}}
